import { PlpHeader } from '@/features/plp/presentation/components/PlpHeader';
import { PlpHeader as PlpHeaderV2 } from '@/features/plp/presentation/components/PlpHeader_v2';
import { RECENTLY_VIEWED_HEADER } from '../../infra/mappers/browsingHistory.mapper';

export function RecentlyViewedHeader({ totalCount }: { totalCount?: number }) {
  return (
    <>
      <div className="md:hidden">
        <PlpHeaderV2 title="Recently Viewed" exploreLinks={[]} showDesktopBanner={false} />
      </div>
      <div className="hidden md:block">
        <PlpHeader title={RECENTLY_VIEWED_HEADER} totalCount={totalCount} countLabel="Designs" showDesktopBanner={false} />
      </div>
    </>
  );
}
